import { Scheduler } from '../../components/scheduler/Scheduler.jsx'
// import styles from './styles.module.css'
import { TimeLineHeader } from './TimeLineHeader.jsx'
import { TimeLineProfileFilters } from './TimeLineProfileFilters.jsx'
import { useEffect, useState } from 'react'
import {
	getEvents,
	createEvents,
	updateEvent,
	deleteEvents,
} from '../../features/schedulerSlice.js'
import { fetchEventTags } from '../../features/guestListSlice.js'
import {
	getKazooMembers,
	getKazooVenues,
} from '../../features/kazooEventSlice.js'
import { getKazooVendors, getVendors } from '../../features/vendorSlice.js'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { toastHelper } from '../../util/toastHelper.js'
import { PushEventsModal } from '../../components/popups/scheduler/PushEventsModal.jsx'
import { useTutorial } from '../../context/TutorialContext'
import { useTutorialStatus } from '../../hooks/useTutorialStatus'
import styles from './timeLineStyle.module.scss'
import Progress from '../../components/UserDashboard/WeddingDashboard/Survey/Progress/Progress.jsx'

export const UserTimelinePage = () => {
	const dispatch = useDispatch()
	const { kazooId } = useParams()
	const [movedEvent, setMovedEvent] = useState({})
	const [moveEventModal, setMoveEventModal] = useState(false)
	const [step, setStep] = useState(0)

	// Tutorial hooks
	const { hasSeenTutorial, isLoading } = useTutorialStatus('timeline')
	const { startTutorial, isTutorialActive } = useTutorial()

	// Tutorial effect
	useEffect(() => {
		if (!isLoading && !hasSeenTutorial && !isTutorialActive()) {
			const timer = setTimeout(() => {
				startTutorial('timeline')
			}, 1000)
			return () => clearTimeout(timer)
		}
	}, [isLoading, hasSeenTutorial, isTutorialActive, startTutorial])

	const role = useSelector((state) => state.kazooEvent.role)
	const partyMembers = useSelector((state) => state.scheduler.selectedUsers)
	const timelineEvents = useSelector(
		(state) => state.scheduler.timelineEvents
	)

	useEffect(() => {
		if (kazooId) {
			dispatch(getEvents(kazooId)) // to display events
			dispatch(fetchEventTags(kazooId))
			dispatch(getKazooVenues(kazooId)) // for location dropdown
			dispatch(getKazooVendors(kazooId)) // for vendors dropdown (wedding-specific)
			dispatch(getVendors({ limit: 1000 })) // for all vendors list
			dispatch(getKazooMembers(kazooId)) // for selectedUsers
		}
	}, [dispatch, kazooId])

	const isOverlapping = (event) => {
		if (event.IsAllDay) return false

		const startTime = new Date(event.StartTime)
		const endTime = new Date(event.EndTime)

		for (let i = 0; i < timelineEvents.length; i++) {
			const existingEvent = timelineEvents[i]
			// Convert one list to a Set for efficient lookups
			const set = new Set(existingEvent.OwnerIds)

			// check if both events contain a similar OwnerId
			const hasCommonOwnerId = event.OwnerIds.some((OwnerId) =>
				set.has(OwnerId)
			)
			if (
				!hasCommonOwnerId ||
				existingEvent._id === event._id ||
				existingEvent.IsAllDay
			) {
				continue // Skip to the next iteration
			}

			const existingStartTime = new Date(existingEvent.StartTime)
			const existingEndTime = new Date(existingEvent.EndTime)

			if (
				(existingStartTime <= startTime &&
					startTime < existingEndTime) ||
				(existingStartTime < endTime && endTime <= existingEndTime) ||
				(existingStartTime <= startTime &&
					endTime <= existingEndTime) ||
				(existingStartTime >= startTime && endTime >= existingEndTime)
			) {
				return true
			}
		}
		return false
	}

	// ------- COULD BE OPTIMIZED ??? --------
	const pushConflictingEvents = () => {
		// filters out events that end before the updated one for better time complexity
		const updatedEvents = [movedEvent]
		let existingEvents = [...timelineEvents].filter((event) => {
			const changedStartTime = new Date(movedEvent.StartTime).getTime()
			const eventEndTime = new Date(event.EndTime).getTime()
			return (
				changedStartTime < eventEndTime &&
				event._id !== movedEvent._id &&
				!event.IsAllDay
			)
		})

		// filter out duplicate events (since treat events with multiple attendees as seperate)
		const seenIds = new Set() // for efficient lookup
		let uniqueEvents = []

		for (const event of existingEvents) {
			const eventId = event._id
			if (!seenIds.has(eventId)) {
				uniqueEvents.push(event)
				seenIds.add(eventId)
			}
		}

		// sort list by StartTime
		uniqueEvents = uniqueEvents.sort((a, b) => {
			const dateA = new Date(a.StartTime)
			const dateB = new Date(b.StartTime)

			return dateA.getTime() - dateB.getTime()
		})

		let data = pushConflictingEventsHelper(
			updatedEvents,
			uniqueEvents,
			false
		)

		while (data.conflictingEvents.length > 0) {
			updatedEvents.push(...data.conflictingEvents)
			data = pushConflictingEventsHelper(
				data.conflictingEvents,
				data.tempList,
				data.locked
			)
		}

		if (data.locked)
			toastHelper(
				'One or more events were locked and were not moved. Please check the conflicts',
				'error'
			)

		dispatch(
			updateEvent({
				events: updatedEvents,
				kazooId: kazooId,
			})
		)
	}
	const pushConflictingEventsHelper = (
		updatedEvents,
		existingEvents,
		encounteredLockedEvent
	) => {
		let conflictingEvents = []
		let eventIds = []
		let latestEndTimes = {} // dictionary to keep track of latest end times for each OwnerId
		let locked = encounteredLockedEvent

		// populate latestEndTimes list
		for (const updatedEvent of updatedEvents) {
			for (const OwnerId of updatedEvent.OwnerIds) {
				const endTime = new Date(updatedEvent.EndTime)
				if (latestEndTimes[OwnerId]) {
					if (latestEndTimes[OwnerId] < endTime)
						latestEndTimes[OwnerId] = endTime
				} else {
					latestEndTimes[OwnerId] = endTime
				}
			}
		}

		let tempList = existingEvents
		for (const updatedEvent of updatedEvents) {
			eventIds.push(updatedEvent._id)
			const startTime = new Date(updatedEvent.StartTime)
			const endTime = new Date(updatedEvent.EndTime)

			for (let i = 0; i < tempList.length; i++) {
				const existingEvent = tempList[i]
				// Convert one list to a Set for efficient lookups
				const set = new Set(existingEvent.OwnerIds)

				// check if both events contain a similar OwnerId
				const hasCommonOwnerId = updatedEvent.OwnerIds.some((OwnerId) =>
					set.has(OwnerId)
				)
				if (
					!hasCommonOwnerId ||
					existingEvent._id === updatedEvent._id
				) {
					continue // Skip to the next iteration
				}

				const existingStartTime = new Date(existingEvent.StartTime)
				const existingEndTime = new Date(existingEvent.EndTime)

				if (
					(existingStartTime <= startTime &&
						startTime < existingEndTime) ||
					(existingStartTime < endTime &&
						endTime <= existingEndTime) ||
					(existingStartTime <= startTime &&
						endTime <= existingEndTime) ||
					(existingStartTime >= startTime &&
						endTime >= existingEndTime)
				) {
					if (existingEvent.Locked) {
						locked = true
						continue
					}
					// calculate event duration of current event
					let eventDur = existingEndTime - existingStartTime

					let newStartTime = new Date(endTime)
					let newEndTime = new Date(endTime.getTime() + eventDur)
					for (const OwnerId of existingEvent.OwnerIds) {
						if (latestEndTimes[OwnerId]) {
							newStartTime = Math.max(
								newStartTime,
								new Date(latestEndTimes[OwnerId])
							)
							newEndTime = Math.max(
								newEndTime,
								new Date(
									latestEndTimes[OwnerId].getTime() + eventDur
								)
							)
						}
					}
					// updated latest end times
					for (const OwnerId of existingEvent.OwnerIds) {
						latestEndTimes[OwnerId] = new Date(newEndTime)
					}

					const shiftedEvent = {
						...existingEvent,
						StartTime: newStartTime,
						EndTime: newEndTime,
					}

					// add new event to conflicting events list
					conflictingEvents.push(shiftedEvent)

					tempList[i] = shiftedEvent // Update the original array
				}
			}
		}
		tempList = tempList.filter(
			(existingEvent) => !eventIds.includes(existingEvent._id)
		)
		return { conflictingEvents, tempList, locked }
	}

	// Function to handle saving events to the server
	const onActionBegin = async (args) => {
		if (
			args.requestType === 'eventCreate' ||
			args.requestType === 'eventChange' ||
			args.requestType === 'eventRemove'
		) {
			if (role === 'guest') {
				return toastHelper(
					'You only have view permissions as a guest',
					'error'
				)
			}
			try {
				let events = args.data // Get the event data
				args.cancel = true // prevent default actions (modifying immutable list causes error)

				if (args.requestType === 'eventCreate') {
					if (!events[0].EventCategory)
						return toastHelper(
							'Please provide an event category',
							'error'
						)

					const start = new Date(events[0].StartTime);
					const end = new Date(events[0].EndTime);

					if (isNaN(start.getTime()) || isNaN(end.getTime())) {
						return toastHelper('Invalid date or time selected', 'error');
					}

					if (start >= end) {
						return toastHelper('End time must be after start time', 'error')
					}
					const raw = events[0]

					const syncToCalendar = {
						google: raw.SyncGoogle !== false,
						outlook: raw.SyncOutlook !== false,
						ical: raw.SyncIcal !== false,
					  }

					  
					if (raw?.OwnerIds?.length) {
						dispatch(
							createEvents({
								events: {
									...raw,
									syncToCalendar,
								},
								kazooId: kazooId,
							})
						)
					} else {
						if (!raw?.OwnerId)
							return toastHelper(
								'Please select at least one attendee',
								'error'
							)
						dispatch(
							createEvents({
								events: {
									...raw,
                                    EventColor: raw?.EventColor || '#dfeef4',
									OwnerIds: [raw.OwnerId],
									syncToCalendar,
								},
								kazooId,
							})
						)
					}
				}
				if (args.requestType === 'eventChange') {
					if (!events.OwnerIds.length) {
						return toastHelper(
							'Please select at least one attendee',
							'error'
						)
					}

					const start = new Date(events.StartTime);
					const end = new Date(events.EndTime);

					if (isNaN(start.getTime()) || isNaN(end.getTime())) {
						return toastHelper('Invalid date or time selected', 'error');
					}

					if (start >= end) {
						return toastHelper('End time must be after start time', 'error')
					}
					const syncToCalendar = {
						google: events.SyncGoogle !== false,
						outlook: events.SyncOutlook !== false,
						ical: events.SyncIcal !== false,
					}
					// Open modal here
					setMovedEvent(events)
					if (isOverlapping(events)) setMoveEventModal(true)
					dispatch(
						updateEvent({
							events: [
								{
									...events,
									OwnerIds: events.OwnerIds?.map((owner) => {
										if (owner.id) return owner.id
										return owner
									}),
									syncToCalendar,
								},
							],
							kazooId: kazooId,
						})
					)
				}
				if (args.requestType === 'eventRemove')
					dispatch(
						deleteEvents({
							ids: events.map((event) => event._id),
							kazooId,
						})
					)
			} catch (error) {
				console.error('Error saving event:', error)
			}
		}
	}

	const lockedEventAction = (args) => {
		if (args.data.Locked) {
			args.cancel = true
		}
	}

	const eventSettings = {
		allowAdding: role !== 'guest',
		allowEditing: role !== 'guest',
		allowDeleting: role !== 'guest',
		allowResizing: role !== 'guest',
		allowDrag: role !== 'guest',
		dataSource: timelineEvents.map((event) => ({
			...event,
		})),
	}

	return (
		<>
			<div className={styles.pageWrap}>
				{moveEventModal && (
					<PushEventsModal
						open={moveEventModal}
						toggleModal={setMoveEventModal}
						pushConflictingEvents={pushConflictingEvents}
					/>
				)}
				<TimeLineHeader />
				<Progress step={step} />
				<TimeLineProfileFilters />
				<div className={styles.schedulerWrap}>
					<div className="calendarWrp commonCalendar ">
						<div className="calendarInner">
							<Scheduler
								onActionBegin={onActionBegin}
								eventSettings={eventSettings}
								partyMembers={partyMembers}
								dragStart={lockedEventAction}
								resizeStart={lockedEventAction}
								height="77dvh"
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
